import { createContext, useContext, useState, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const DURATION = 900; // ms — must match CSS animation duration

const TransitionContext = createContext(null);

export function TransitionProvider({ children }) {
  const [phase, setPhase] = useState('idle'); // 'idle' | 'exiting' | 'entering'
  const navigate = useNavigate();
  const transitioning = useRef(false);

  const navigateTo = useCallback((path) => {
    if (transitioning.current) return;
    transitioning.current = true;
    setPhase('exiting');
    setTimeout(() => {
      navigate(path);
      setPhase('entering');
      setTimeout(() => {
        setPhase('idle');
        transitioning.current = false;
      }, DURATION);
    }, DURATION);
  }, [navigate]);

  return (
    <TransitionContext.Provider value={{ phase, navigateTo }}>
      {children}
    </TransitionContext.Provider>
  );
}

export function usePageTransition() {
  return useContext(TransitionContext);
}
